import def from './component';

export * from './component';

export default def;
